import React from 'react'
import SubscriptionPanel from '@/components/SubscriptionPanel'

const Page: React.FC = () => {
  return (
    <div>
      <SubscriptionPanel />
    </div>
  )
}

export default Page
